/* eslint-disable */
'use client';

import { cn } from '@/lib/ui/cn';
import { ComponentPromoBannerProps } from '@/types/components';
import * as React from 'react';
import CloseIcon from '../../icons/Close';
import { BANNER_THEMES } from './bannerTheme';

type PromoBannerProps = ComponentPromoBannerProps & {
  onClose: () => void;
};

export function PromoBanner({
  content,
  colorTheme,
  onClose,
}: PromoBannerProps) {
  const theme = BANNER_THEMES[colorTheme];
  const bannerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const height = bannerRef.current?.offsetHeight ?? 0;
    document.documentElement.style.setProperty(
      '--promo-banner-h',
      `${height}px`
    );
    return () => {
      document.documentElement.style.removeProperty('--promo-banner-h');
    };
  }, []);

  return (
    <div
      ref={bannerRef}
      data-component='promo-banner'
      data-testid='promo-banner'
      className={cn(
        'flex items-center justify-between space-x-5 px-5 py-3.5',
        theme.container
      )}
    >
      <div
        data-testid='promo-banner-content'
        className={cn(
          'w-full font-sans text-[16px] leading-[130%] font-normal tracking-[1%] md:text-center',
          theme.content
        )}
        dangerouslySetInnerHTML={{ __html: content }}
      />

      <button
        onClick={onClose}
        className='cursor-pointer'
        aria-label='Close banner'
      >
        <CloseIcon className={cn('size-6', theme.close)} strokeWidth={2} />
      </button>
    </div>
  );
}
